
const Managers = ({data, choose, active, photo}) => {

    return (
        <div className={photo ? "managers" : "managers managers_notphoto"}>
            {data && data.map((item, i) => (
                    <div className={active && active.id == item.id ? "managers__item managers__item_choosen" : "managers__item"} key={i} onClick={() => choose && choose(item)}>
                        <div className="managers__top">
                            <div className="managers__name">{item.name}</div>
                            {/*<div className="managers__rating">{item.rating}</div>*/}
                        </div>
                        <div className="managers__contacts">
                            {item.phone && <div className="managers__phone"><a href={`tel:${item.phone}`}><nobr>{item.phone}</nobr></a></div>}
                            {item.email && <div className="managers__email"><a href={`mailto:${item.email}`}>{item.email}</a></div>}
                        </div>
                    </div>
                ))
            }                
        </div>
    )
}

export default Managers